import { convertListToObjectBy } from '@beef/utils';

import { DeliveryRouteDeliveryModel } from '../../api/data-contracts';
import {
  CourierIntervalsVersion,
  DeliveryIntervalsPerDateModelWithVersion,
  DeliveryRouteDeliveryModelWithVersion,
  JoinedRoutesResponse,
} from './types';

export * from './types';

export const joinCourierRequests = (
  responses: DeliveryRouteDeliveryModelWithVersion[],
): JoinedRoutesResponse => {
  const intervalsByDate = responses.reduce<JoinedRoutesResponse['intervalsByDate']>(
    (result, response) => ({
      ...result,
      ...convertListToObjectBy('date')(response?.intervalsPerDate || []),
    }),
    {},
  );

  return {
    defaultCity: {
      id: responses[0]?.defaultCity?.id || responses[1]?.defaultCity?.id,
      isSelfRegistrationOnly: responses[1]?.defaultCity?.isSelfRegistrationOnly,
      name: responses[0]?.defaultCity?.name || responses[1]?.defaultCity?.name,
    },
    intervalsByDate,
    intervalsPerDate: Object.values(intervalsByDate || {}),
  };
};

export const handleRoutesV2Request = (
  response: DeliveryRouteDeliveryModelWithVersion,
): JoinedRoutesResponse => {
  const intervalsByDate = convertListToObjectBy('date')(response?.intervalsPerDate || []);
  return {
    defaultCity: {
      id: response?.defaultCity?.id,
      isSelfRegistrationOnly: response?.defaultCity?.isSelfRegistrationOnly,
      name: response?.defaultCity?.name,
    },
    intervalsByDate,
    intervalsPerDate: Object.values(intervalsByDate || {}),
  };
};

export const enrichIntervalsWithVersion =
  (version: CourierIntervalsVersion) =>
  (route: DeliveryRouteDeliveryModel): DeliveryRouteDeliveryModelWithVersion => ({
    ...route,
    intervalsPerDate: route?.intervalsPerDate
      ?.filter((item) => !!item.date)
      .map((item) => ({ ...item, version }) as DeliveryIntervalsPerDateModelWithVersion),
  });
